import { z } from "zod";

export enum ENewPasswordNonEligibleReasonType {
  PARTNER_IS_EKWATEUR = "PARTNER_IS_EKWATEUR",
  NO_APPLIANCE_INSTALLED = "NO_APPLIANCE_INSTALLED",
  MULTISITE = "MULTISITE",
  NO_INSTALLATION_DATE = "NO_INSTALLATION_DATE",
  INSTALLATION_DATE_IS_TOO_OLD = "INSTALLATION_DATE_IS_TOO_OLD",
  TOO_MANY_APPLIANCES = "TOO_MANY_APPLIANCES",
  TERTIARY_SITE = "TERTIARY_SITE",
  UNKNOWN = "UNKNOWN",
}

export const subscriberNewPasswordDtoSchema = z.object({
  isMailSent: z.boolean(),
  nonEligibleToMyV2022ReasonType: z.nativeEnum(ENewPasswordNonEligibleReasonType).nullable(),
});

export type TSubscriberNewPasswordDto = z.infer<typeof subscriberNewPasswordDtoSchema>;
